import React from 'react';
import PropTypes from 'prop-types';
import dateTimeHelper from 'infrastructure/js/utils/dateTimeHelper';
import DeleteIcon from '../../../../assets/svg/delete-icon.svg';
import './aiAssistantHistoryRow.scss';

export default function AiAssistantHistoryRow({ labels, conversation, onOpen, onDelete }) {
  const title = conversation.title || labels.get('history.untitled', 'Untitled conversation');

  const handleDeleteClick = (e) => {
    e.stopPropagation();
    onDelete();
  };

  return (
    <div className="ais-history-row" onClick={onOpen}>
      <div className="ais-history-row-main">
        <div className="ais-history-row-title">{title}</div>
        <div className="ais-history-row-meta">
          <span>{dateTimeHelper.DateTimeFormatAsIs(conversation.lastMessageDate)}</span>
          <span className="ais-history-row-dot">·</span>
          <span>{labels.get('history.messageCount', `${conversation.messageCount} messages`, { count: conversation.messageCount })}</span>
        </div>
      </div>
      <button
        className="ais-history-row-delete"
        onClick={handleDeleteClick}
        title={labels.get('history.button.delete', 'Delete')}
        aria-label={labels.get('history.button.delete', 'Delete')}
      >
        <DeleteIcon />
      </button>
    </div>
  );
}

AiAssistantHistoryRow.propTypes = {
  labels: PropTypes.object.isRequired,
  conversation: PropTypes.object.isRequired,
  onOpen: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
};
